/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import APIManager from "../../ApiManager/ApiManager";
import { FETCH_CLUSTER_DETAILS_REQUEST, FETCH_CLUSTER_DETAILS_SUCCESS, FETCH_CLUSTER_DETAILS_FAILURE } from "./ClusterCompatibilityTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchClusterDetailsRequest = () => {
    return {
      type: FETCH_CLUSTER_DETAILS_REQUEST,
    };
  };
  
  export const fetchClusterDetailsSuccess = (clusterData) => {
    return {
      type: FETCH_CLUSTER_DETAILS_SUCCESS,
      payload: clusterData,
    };
  };
  
  export const fetchClusterDetailsFailure = (error) => {
    return {
      type: FETCH_CLUSTER_DETAILS_FAILURE,
      payload: error,
    };
  };
  
  export const fetchClusterDetails = () => {
    return async function (dispatch) {
      dispatch(fetchClusterDetailsRequest());
      try {
        const data = await APIManager.getClusters();
        dispatch(fetchClusterDetailsSuccess(data));
      } catch (error) {
        dispatch(fetchClusterDetailsFailure(error));
        dispatch(commonError(error,FETCH_CLUSTER_DETAILS_FAILURE));
      }
    };
  };
  
  export const commonError=(error,errorType)=>{
    return({
      type:COMMON_ERROR,
      payload:{
        message:error.message,
        errorType:errorType
      }
    })
  }
  
